import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from '@angular/common/http/';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { isNil } from 'lodash';
import { EnvironmentConfigService } from '../environment';

@Injectable()
export class HttpQueryParametersSanitizationInterceptorService
  implements HttpInterceptor
{
  dictionary: string[] = [
    ' AND',
    ' OR',
    '1=1',
    ' DROP',
    ' DELETE',
    '--',
    ';',
    ' TABLE',
  ];
  platformUrl: string;
  iftaUrl: string;

  constructor(private environmentConfigService: EnvironmentConfigService) {
    this.platformUrl =
      this.environmentConfigService.getEnvironmentConfigs().apis.platform.url;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const regexPlatform = new RegExp(this.platformUrl, 'ig');
    const regexIfta = new RegExp(this.iftaUrl, 'ig');
    if (regexPlatform.test(req.url) || regexIfta.test(req.url)) {
      if (req.method === 'GET') {
        return next.handle(this.sanitizeGET(req));
      } else if (req.method === 'POST') {
        return next.handle(this.sanitizePOST(req));
      } else {
        return next.handle(req);
      }
    } else {
      return next.handle(req);
    }
  }

  sanitizeGET(req: HttpRequest<any>): HttpRequest<any> {
    let newParams: HttpParams = new HttpParams();

    req.params.keys().forEach((key) => {
      newParams = newParams.set(key, req.params.get(key));
      this.dictionary.forEach((dictionaryWord) => {
        const modifiedValue = newParams.get(key);
        const regex = new RegExp(dictionaryWord, 'ig');
        if (regex.test(modifiedValue)) {
          newParams = newParams.set(
            key,
            modifiedValue.replace(regex, '').trim()
          );
        }
      });
    });
    return req.clone({ params: newParams });
  }

  sanitizePOST(req: HttpRequest<any>): HttpRequest<any> {
    if (!isNil(req.body) && typeof req.body === 'object') {
      const newBody = this.sanitizeObject(req.body);
      return req.clone({ body: newBody });
    } else {
      return req;
    }
  }

  sanitizeObject(body: Object): Object {
    const newBody = body;
    const properties = Object.entries(newBody);
    properties.forEach((element) => {
      if (Array.isArray(element[1])) {
        element[1].forEach((entry: string, index) => {
          this.dictionary.forEach((dictionaryWord) => {
            const regex = new RegExp(dictionaryWord, 'ig');
            if (regex.test(entry)) {
              entry = entry.replace(regex, '').trim();
            }
          });
          newBody[element[0]][index] = entry;
        });
      } else if (typeof element[1] === 'string') {
        this.dictionary.forEach((dictionaryWord) => {
          const regex = new RegExp(dictionaryWord, 'ig');
          if (regex.test(element[1].toString())) {
            element[1] = element[1].toString().replace(regex, '').trim();
          }
        });
        newBody[element[0]] = element[1];
      } else if (typeof element[1] === 'object') {
        this.sanitizeObject(element[1]);
      } else {
        newBody[element[0]] = element[1];
      }
    });
    return newBody;
  }
}
